import React from "react";

interface SendEmailProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  email: string;
}

const SendEmail: React.FC<SendEmailProps> = ({
  isOpen,
  onClose,
  onConfirm,
  email,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-md p-6 w-80 text-center">
        <h2 className="text-xl font-semibold mb-2">Konfirmasi</h2>
        <p className="mb-4 text-sm">
          E-Prescription akan dikirim ke Email<br />
          <span className="font-medium">{email}</span>
        </p>
        <div className="flex justify-center gap-4">
          <button
            onClick={onConfirm}
            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1.5 px-6 rounded border border-blue-700"
          >
            Ya
          </button>
          <button
            onClick={onClose}
            className="bg-red-500 hover:bg-red-600 text-white font-semibold py-1.5 px-6 rounded"
          >
            Batal
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendEmail;
